import React, { useState } from 'react';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import css from '../organisms/Table.css';
import ExtendedMenu from '../../resources/svg/extended_menu.svg';
import Tooltip from '../molecules/Tooltip';

const ContextMenu = props => {
    const { items = [], className = '', icon = null, menuDisabled = false, onSelect = () => {} } = props;

    const [show, setShow] = useState(false);

    const itemSelect = item => {
        setShow(false);
        onSelect(item, props);
    };

    const getItem = item => {
        const disabled = typeof item.disabled === 'function' ? item.disabled(props) : item.disabled;

        const itemContent = (
            <>
                {typeof item.name === 'function' ? item.name(props) : <Translate id={item.name} />}
                {!item.isNew ? null : <sup className={css.itemTag}>New</sup>}
                {!item.isBeta ? null : <sup className={css.itemTag}>Beta</sup>}
            </>
        );

        return (
            <li
                id={item.name}
                key={item.name}
                onMouseDown={!disabled ? () => itemSelect(item) : undefined}
                className={`${disabled ? css.disabled : ''}`}
            >
                {item.tooltip ? (
                    <Tooltip wrapperClass={css.menuItemTooltip} titleTranslationKey={item.tooltip}>
                        {itemContent}
                    </Tooltip>
                ) : (
                    itemContent
                )}
            </li>
        );
    };

    const menuToggle = showValue => {
        setShow(showValue);
    };

    const menuContents = !(show && !menuDisabled) ? null : (
        <ul className={`${show ? css.show : ''}`}>{items.map(getItem)}</ul>
    );

    return (
        <div className={classNames(css.dropdownCell, className)}>
            <div role="button" tabIndex="0" onBlur={() => menuToggle(false)}>
                <button onClick={() => menuToggle(!show)} className={`${show ? css.active : ''}`}>
                    {icon || <ExtendedMenu style={{ width: 18, height: 18, position: 'relative', top: '4px' }} />}
                </button>
                {menuContents}
            </div>
        </div>
    );
};

ContextMenu.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            disabled: PropTypes.bool,
            tooltip: PropTypes.string,
            isNew: PropTypes.bool,
            isBeta: PropTypes.bool,
        })
    ),
    className: PropTypes.string,
    icon: PropTypes.node,
    menuDisabled: PropTypes.bool,
    onSelect: PropTypes.func,
};

export default ContextMenu;
